export default __webpack_public_path__ + "static/media/1.50c2e11f.webp";